<template>
  <div id="app">
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
// 屏幕自适应（html zoom 等比缩放；模块已在入口最先加载，此处兜底重算一次）
import { applyAdaptive } from '@/plugins/adaptive.js';
import { initChartResizeListener } from '@/plugins/chartResize.js';
export default {
  name: 'app',
  created() {
    applyAdaptive();
    // 全局 window resize 广播（供 echarts 等自适应监听）
    initChartResizeListener();
  },
  methods: {
    // bodyScale() {
    //   var devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
    //   var scale = devicewidth / 1660; // 分母——设计稿的尺寸
    //   document.body.style.zoom = scale; //放大缩小相应倍数
    // }
  },


}
</script>

<style lang="less" >
div {
  font-size: 14px;
}

.el-table {
  font-size: 14px !important;
}

video {
  background-color: #000;
}

.el-tooltip__popper.is-light {
  max-width: 300px !important;
}

.flex-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.flex-row-start {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
}

.flex-row-end {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
}

.flex-row-start2 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
}

.flex-row-start3 {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-start;
}

.flex-row-start4 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.flex-row-between {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}

.flex-row-between2 {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: space-between;
}

.flex-col {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}

.flex-col-between {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}

.flex-col-start {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: center;
}

.flex-col-end {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-end;
  justify-content: center;
}

.flex-col-end-between {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-end;
  justify-content: space-between;
}

.flex-col-start-between {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: space-between;
}

.hide1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hide2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.hide3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}


.el-cascader-panel {
  height: 300px !important;
}

.font14 {
  font-size: 14px !important;
}

.flex-row-end-start {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-end;
}

/* 滚动条样式 */
/* 选择整个滚动条 */
//   ::-webkit-scrollbar {
//   width: 8px; /* 设置滚动条的宽度 */
//   border-radius: 6px; /* 设置滑块的圆角 */
// }

// /* 选择滚动条滑块 */
// ::-webkit-scrollbar-thumb {
//   background-color: rgb(204, 204, 204); /* 设置滑块的背景颜色 */
//   border-radius: 6px; /* 设置滑块的圆角 */
// }

// /* 选择滚动条轨道 */
// ::-webkit-scrollbar-track {
//   background: #f1f1f1; /* 设置轨道的背景颜色 */
//   border-radius: 6px; /* 设置滑块的圆角 */
// }</style>
